import {ChangeDetectionStrategy, Component, ViewEncapsulation, Input} from '@angular/core';
import {Order} from '../../../models/order.model';
import {SHIPPING_INFO, TAX_EXEMPT_INFO} from '../../../constants/texts';
import {ModalService} from '../../../services/modal.service';
import {MobileCheckServiceService} from '../../../services/mobile-check-service.service';
import {AuthService} from '../../../services/auth.service';

@Component({
    selector: 'app-order-summary',
    templateUrl: './order-summary.component.html',
    styleUrls: ['./order-summary.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrderSummaryComponent {

    @Input() title = 'Order Summary';
    @Input() order: Order;

    constructor(private modalService: ModalService, private mobileCheck: MobileCheckServiceService, private authService: AuthService) {
 
    }

    get shippingInfo(): string {
        return SHIPPING_INFO;
    }

    get taxExemptInfo(): string {
        return TAX_EXEMPT_INFO;
    }

    showBudgetDetails() {
        this.modalService.showBudgetDetails(this.order.items);
        return false;
    }

    get isTaxExemptAllowed(): boolean {
        return this.authService.user.isTaxExemptAllowed || this.order.isWSLR;
    }

    get canShowTaxExempt(): boolean {
        return this.authService.isWholeSaler || this.order.isWSLR;
    }

    get taxExemptOrderHasTaxes(): boolean {
        if (!this.isTaxExemptAllowed) {
            return false;
        }

        if (!this.order.taxExempt) {
            return false;
        }

        return this.order.taxes > 0;
    }
    get mobile(): boolean {
        return this.mobileCheck.mobileDevice;
    }

    get tooltipPosition(): string {
        return this.mobile ? 'bottom-left' : 'bottom';
    }
}
